<ng-template #content let-c="close" let-d="dismiss">
    <form name="frmRec" (submit)="onSubmit()">
        <div class="modal-header">
            <h6 class="modal-title" translate>TITLE.TITLE_RECURRENCE_PATTERN</h6>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
            <div class="card mb-2">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-2">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="RecurrencePattern" id="RecurrencePattern_1" class="custom-control-input" [value]="1" [(ngModel)]="Model.RecurrencePattern">
                                <label class="custom-control-label" for="RecurrencePattern_1" translate>LBL.HOURLY</label>
                            </div>
                        </div>

                        <div class="col-2">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="RecurrencePattern" id="RecurrencePattern_2" class="custom-control-input" [value]="2" [(ngModel)]="Model.RecurrencePattern">
                                <label class="custom-control-label" for="RecurrencePattern_2" translate>LBL.DAILY</label>
                            </div>
                        </div>

                        <div class="col-2">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="RecurrencePattern" id="RecurrencePattern_3" class="custom-control-input" [value]="3" [(ngModel)]="Model.RecurrencePattern">
                                <label class="custom-control-label" for="RecurrencePattern_3" translate>LBL.WEEKLY</label>
                            </div>
                        </div>

                        <div class="col-2">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="RecurrencePattern" id="RecurrencePattern_4" class="custom-control-input" [value]="4" [(ngModel)]="Model.RecurrencePattern">
                                <label class="custom-control-label" for="RecurrencePattern_4" translate>LBL.MONTHLY</label>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col form-inline" *ngIf="Model.RecurrencePattern == enumRP.Hourly"><span translate>LBL.RECURS_EVERY</span> <input type="text" mask="000" name="RecurrenceFrequency_Hours" [(ngModel)]="Model.RecurrenceFrequency" class="mx-2 form-control form-control-sm txt-2" /> Hour(s)</div>
                        <div class="col form-inline offset-2" *ngIf="Model.RecurrencePattern == enumRP.Daily"><span translate>LBL.RECURS_EVERY</span> <input type="text" mask="000" name="RecurrenceFrequency_Days" [(ngModel)]="Model.RecurrenceFrequency" class="mx-2 form-control form-control-sm txt-2" /> Day(s)</div>

                        <!--Weekly-->
                        <div class="col form-inline justify-content-between" *ngIf="Model.RecurrencePattern == enumRP.Weekly">
                            <div *ngFor="let row of Weekdays" class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" name="weekday_{{row}}" id="weekday_{{row}}" [value]="row" [(ngModel)]="selectedWeekdays[row]">
                                <label class="custom-control-label" for="weekday_{{row}}">{{row}}</label>
                            </div>
                        </div>

                        <!--Monthlyy-->
                        <div class="col d-flex flex-column" *ngIf="Model.RecurrencePattern == enumRP.Monthly">
                            <div class="row justify-content-between">
                                <div *ngFor="let row of Days" class="" [ngClass]="row == -1 ? 'col-10' : 'col-2'">
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="custom-control custom-checkbox w-auto">
                                                <input type="checkbox" class="custom-control-input" name="day_{{row}}" id="day_{{row}}" [value]="row" [(ngModel)]="selectedMonthDays[row]">
                                                <label class="custom-control-label" for="day_{{row}}"><span *ngIf="row==-1" translate>LBL.END_OF_MONTH</span><span *ngIf="row!=-1">{{row}}</span></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col d-flex">
                                    <span translate>LBL.RECURS_EVERY</span> <input type="text" mask="000" name="RecurrenceFrequency_Days" [(ngModel)]="Model.RecurrenceFrequency" class="mx-2 form-control form-control-sm txt-2" /> Month(s)
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="card">
                <div class="card-header"><span translate>LBL.RANGE_OF_RECURRENCE</span></div>
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-7">
                            <div class="row align-items-center no-gutters">
                                <div class="col-2"><span translate>LBL.START</span></div>
                                <div class="col-auto ">
                                    <p-calendar name="StartDateTime" [(ngModel)]="Model.StartDateTime" [disabled]="OccurrenceCount > 0" placeholder="{{'PH.PH_YYYY_MM_DD_SLASH' | translate}}" dateFormat="yy/mm/dd" hideOnDateTimeSelect="true" showTime="true" hourFormat="12" showIcon="true" styleClass=""></p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center no-gutters form-group">
                        <div class="col-2">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="EndPattern" id="EndPattern_1" class="custom-control-input" [value]="enumRP_End.EndBy" [(ngModel)]="Model.EndPattern">
                                <label class="custom-control-label" for="EndPattern_1" translate>LBL.END_BY</label>
                            </div>

                        </div>
                        <div class="col-2">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="EndPattern" id="EndPattern_2" class="custom-control-input" [value]="enumRP_End.EndsAfter" [(ngModel)]="Model.EndPattern">
                                <label class="custom-control-label" for="EndPattern_2" translate>LBL.ENDS_AFTER</label>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="!Model.IsGuestCall">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="EndPattern" id="EndPattern_3" class="custom-control-input" [value]="enumRP_End.NoEndDate" [(ngModel)]="Model.EndPattern">
                                <label class="custom-control-label" for="EndPattern_3" translate>LBL.NO_END_DATE</label>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="Model.IsGuestCall">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="EndPattern" id="EndPattern_4" class="custom-control-input" [value]="enumRP_End.NoEndDate" [(ngModel)]="Model.EndPattern">
                                <label class="custom-control-label" for="EndPattern_4" translate>LBL.UPON_CHECKOUT</label>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center no-gutters" *ngIf="Model.EndPattern == enumRP_End.EndBy">
                        <div class="col-auto mr-1">
                            <p-calendar name="EndDateTime" [(ngModel)]="Model.EndDateTime" placeholder="{{'PH.PH_YYYY_MM_DD_SLASH' | translate}}" dateFormat="yy/mm/dd" hideOnDateTimeSelect="true" showTime="true" hourFormat="12" showIcon="true" styleClass=""></p-calendar>
                        </div>
                    </div>

                    <div class="row align-items-center no-gutters" [hidden]="Model.EndPattern != enumRP_End.EndsAfter">
                        <div class="col-auto offset-2">
                            <div class="input-group">
                                <input type="text" mask="000" class="form-control txt-3" id="MaxRecurrence" name="MaxRecurrence" [(ngModel)]="Model.MaxRecurrence" />
                                <div class="input-group-append">
                                    <span class="input-group-text" translate>LBL.OCCURRENCES</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row mt-3">
                        <div class="col-auto"><span translate>LBL.ROOM_STATUS</span></div>
                        <div class="col-auto">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="RoomStatus_O" id="RoomStatus_O" [value]="'O'" [(ngModel)]="Model.RoomStatus" />
                                <label class="form-check-label" for="RoomStatus_O" translate>LBL.OCCUPIED</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="RoomStatus_V" id="RoomStatus_V" [value]="'V'" [(ngModel)]="Model.RoomStatus" [disabled]="Model.IsGuestCall" />
                                <label class="form-check-label" for="RoomStatus_V" translate>LBL.VACANT</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="RoomStatus_A" id="RoomStatus_A" [value]="'A'" [(ngModel)]="Model.RoomStatus" [disabled]="Model.IsGuestCall" />
                                <label class="form-check-label" for="RoomStatus_A" translate>LBL.BOTH</label>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <div class="modal-footer">
            <button type="submit" [disabled]="IsSubmitting" class="btn btn-primary" translate>BTN.BTN_SAVE</button>
            <button type="button" [disabled]="IsSubmitting" class="btn btn-secondary" (click)="c('close')" translate>BTN.BTN_CLOSE</button>
        </div>
    </form>
</ng-template>
